import { Capacitor } from "@capacitor/core";

/**
 * Copies text to clipboard using the Capacitor plugin on native platforms,
 * falling back to the browser Clipboard API on web.
 */
export async function copyToClipboard(text: string): Promise<void> {
  if (Capacitor.isNativePlatform()) {
    const { Clipboard } = await import("@capacitor/clipboard");
    await Clipboard.write({ string: text });
  } else {
    await navigator.clipboard.writeText(text);
  }
}
